<template>
  <div>
    <h4>{{ $t("personalInformations") }}</h4>
    <div v-if="clientType != 1" is="company-informations" />
    <div v-if="clientType === 1" is="personal-informations" />
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import CompanyInformations from "./CompanyInformations.vue";
import PersonalInformations from "./PersonalInformations.vue";
export default {
  name: "Client-informations",
  components: {
    "company-informations": CompanyInformations,
    "personal-informations": PersonalInformations,
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  computed: {
    ...mapFields(["user"]),
    clientType() {
      return this.$lodash.get(this.user, "clientType", 0);
    },
  },
  created() {
    this.isLoaded = true;
  },
  methods: {},
};
</script>

<style></style>
